export default __webpack_public_path__ + "static/media/htw1.5769b0dd.svg";